// TOP LEVEL IMPORTS
import React from 'react';
import Truncate from 'react-truncate';
// ANTD
import Table from 'antd/lib/table';
// APOLLO
import questionTemplatesQuery from 'ApolloClient/Queries/questionTemplates';
import { graphql } from 'react-apollo';
import ActionMenu from './ActionMenu';

const expandedRowRender = record => {
  if (!record || !record.questions || !record.questions.length || record.questions.length === 0) {
    return null;
  }
  return (
    <div>
      <h3>Questions:</h3>
      {record.questions.map((question, i) => (
        <p key={question + i}>{`${i + 1}. ${question}`}</p>
      ))}
    </div>
  );
};

const columns = [
  {
    title: 'TITLE',
    dataIndex: 'title',
    key: 'title',
    width: 250,
    render: (text, record) => (
      <Truncate lines={3} ellipsis={<span>...</span>}>
        {(record && record.title) || ''}
      </Truncate>
    ),
  },
  {
    title: '#',
    dataIndex: 'questions',
    key: 'questions',
    render: (text, record) => <span>{record.questions.length}</span>,
  },
  {
    title: 'ACTIONS',
    width: 120,
    render: (text, record) => <ActionMenu record={record} />,
  },
];

export class QuestionTemplatesTable extends React.Component {
  render = () => {
    const { loading, questionTemplates } = this.props.questionTemplatesQuery;

    return (
      <div style={{ marginTop: 10 }}>
        <Table
          rowKey={record => record._id}
          columns={columns}
          loading={loading}
          expandedRowRender={expandedRowRender}
          pagination={{
            defaultPageSize: 5,
          }}
          dataSource={questionTemplates}
        />
      </div>
    );
  };
}

export default graphql(questionTemplatesQuery, { name: 'questionTemplatesQuery' })(QuestionTemplatesTable);



// WEBPACK FOOTER //
// ./src/routes/app-studio/QuestionTemplatesArea/QuestionTemplatesTable/index.js